module.exports = __webpack_public_path__ + "images/aa-migration-wizard/illustration-email-mobile.289099c187e0cc1861ee.svg";